import GameIds from './GameIds';
import AssessmentIds from './AssessmentIds';

export default {
  reading: {
    gameDisplayNames: {
      [GameIds.ALL_ABOARD]: 'All Aboard!',
      [GameIds.BECAUSE_THIS_THAT]: 'Because, This, That',
      [GameIds.BEST_BUDDY]: 'Best Buddy',
      [GameIds.BLENDING]: 'Blending',
      [AssessmentIds.BLENDING_PLACEMENT]: 'Blending',
      [GameIds.BOOK_CLUB]: 'Book Club',
      [GameIds.CITY_PLANNER]: 'City Planner',
      [GameIds.CODEX]: 'CodeX',
      [GameIds.CONNECT_IT]: 'Connect It!',
      [GameIds.CURIOSO_CROSSING]: 'Curioso Crossing',
      [GameIds.CURIOSO_CALLING]: 'Curioso Calling',
      [GameIds.CURIOUS_CASES]: 'Curious Cases',
      [GameIds.CUT_IT_OUT]: 'Cut It Out',
      [GameIds.DEBATE_A_BALL]: 'Debate-a-Ball',
      [GameIds.DIRECTORS_CUT]: 'Director\'s Cut',
      [GameIds.ESTA_O_AQUELLA]: '¿Esta o Aquella?',
      [GameIds.FIELD_OBSERVER]: 'Field Observer',
      [GameIds.FOOD_TRUCK]: 'Food Truck',
      [GameIds.FOOD_TRUCK_CHEFS_SPECIALS]: 'Chef’s Specials',
      [GameIds.FOTO_FOTO_COGNADO]: 'Foto, foto ¡Cognado!',
      [GameIds.GEM_NYE_FRIENDS]: 'Gem & Nye',
      [GameIds.GRUMPY_GOBLINS]: 'Grumpy Goblins',
      [GameIds.HANGRY_GOBLINS]: 'Hangry Goblins',
      [GameIds.IDIOMATICA]: 'Idiomatica',
      [GameIds.INKBLOTT]: 'Ink Blott',
      [GameIds.JUEGA_Y_CONJUGA]: 'Juega y Conjuga',
      [GameIds.LA_RANA_BRINCACHARCOS]: 'Lilypad Leap',
      [GameIds.LETTER_SOUND_CORRESPONDENCES]: 'Letter Sound Correspondences',
      [AssessmentIds.LETTER_SOUND_CORRESPONDENCES_PLACEMENT]: 'Letter Sound Correspondences',
      [GameIds.MIND_THE_GAP]: 'Mind the Gap',
      [AssessmentIds.MIND_THE_GAP_PLACEMENT]: 'Mind the Gap',
      [GameIds.MESSAGE_IN_A_BOTTLE]: 'Message in a Bottle',
      [GameIds.NEWSFLASH]: 'Newsflash',
      [GameIds.BOOST_FLUENCY]: 'Boost Fluency',
      [GameIds.PARROT_THEATER]: 'Parrot Theater',
      [GameIds.PICKY_GOBLINS]: 'Picky Goblins',
      [GameIds.PICTURE_THIS]: 'Picture This',
      [GameIds.PLANTORRES]: 'PlanTorres',
      [GameIds.POETS_PATH]: 'Poet\'s Path',
      [GameIds.PUNCHLINE]: 'Punchline!',
      [GameIds.READ_ALL_ABOUT_IT]: 'Read All About It',
      [GameIds.REAL_WORD_READING]: 'Real Word Reading',
      [AssessmentIds.REAL_WORD_READING_PLACEMENT]: 'Real Word Reading',
      [GameIds.RHYME_TIME]: 'Rhyme Time',
      [GameIds.SEGMENTING]: 'Segmenting',
      [GameIds.SHADES_OF_MEANING]: 'Shades of Meaning',
      [GameIds.SHOW_OFF]: 'Show Off',
      [GameIds.SILABALON]: 'Silabalón',
      [GameIds.SILABALON_LA_COPA]: 'Silabalón: La Copa',
      [GameIds.SLOPPY_SCROLLS]: 'Sloppy Scrolls',
      [GameIds.SORT_IT_OUT]: 'Sort It Out',
      [GameIds.STICKER_BOOK]: 'Sticker Book',
      [GameIds.STORYLAB]: 'Story Lab',
      [GameIds.CARTOON_FACTORY]: 'Cartoon Factory',
      [GameIds.SEGMENTING]: 'Segmenting',
      [AssessmentIds.SEGMENTING_PLACEMENT]: 'Segmenting',
      [GameIds.STORYBOARD]: 'Storyboard',
      [GameIds.STORYBOX]: 'Storybox',
      [GameIds.SYLLABLE_DECODING]: 'Syllable Decoding',
      [AssessmentIds.SYLLABLE_DECODING_PLACEMENT]: 'Syllable Decoding',
      [GameIds.SUPER_MATCH]: 'Super Match',
      [GameIds.TONGUE_TWIST]: 'Tongue Twist',
      [GameIds.TUBE_TALES]: 'Tube Tales',
      [GameIds.UNMASK_THAT]: 'Unmask That',
      [GameIds.WHATS_THE_BIG_IDEA]: 'What\'s The Big Idea',
      [GameIds.WILD_PLANET]: 'Wild Planet',
      [GameIds.WORD_CITY]: 'Word City',
      [GameIds.WORD_RAIDERS]: 'Word Raiders',
      [GameIds.WORD_SLIDE]: 'Word Slide',
      [GameIds.WORDBOTS]: 'Wordbots',
      [GameIds.YEARBOOK]: 'Yearbook',
      [GameIds.ZOOM_BOOM]: 'Zoom Boom',
      [GameIds.E_READER]: 'eReader',
      [GameIds.ROBOVOICE_PROTOTYPE]: 'Robovoice Prototype',
    },
  },
  lectura: {
    gameDisplayNames: {
      [GameIds.ALL_ABOARD]: '¡Todos a Bordo!',
      [GameIds.BECAUSE_THIS_THAT]: 'Because, This, That',
      [GameIds.BEST_BUDDY]: 'Best Buddy',
      [GameIds.BLENDING]: 'Blending',
      [AssessmentIds.BLENDING_PLACEMENT]: 'Blending',
      [GameIds.BOOK_CLUB]: 'Book Club',
      [GameIds.CITY_PLANNER]: 'City Planner',
      [GameIds.CODEX]: 'CodeX',
      [GameIds.CONNECT_IT]: '¡Conéctalo!',
      [GameIds.CURIOSO_CROSSING]: '¡Cruza Curioso!',
      [GameIds.CURIOSO_CALLING]: 'Curioso Calling',
      [GameIds.CURIOUS_CASES]: 'Curious Cases',
      [GameIds.CUT_IT_OUT]: '1, 2, 3... ¿Cuál es?',
      [GameIds.DEBATE_A_BALL]: 'Debate-a-Ball',
      [GameIds.DIRECTORS_CUT]: 'Director\'s Cut',
      [GameIds.ESTA_O_AQUELLA]: '¿Esta o Aquella?',
      [GameIds.FIELD_OBSERVER]: 'Field Observer',
      [GameIds.FOOD_TRUCK]: 'Food Truck',
      [GameIds.FOOD_TRUCK_CHEFS_SPECIALS]: 'Chef’s Specials',
      [GameIds.FOTO_FOTO_COGNADO]: 'Foto, foto ¡Cognado!',
      [GameIds.GEM_NYE_FRIENDS]: 'Alfa y Beto',
      [GameIds.GRUMPY_GOBLINS]: 'Tragaletras Gruñones',
      [GameIds.HANGRY_GOBLINS]: 'Tragaletras Comelones',
      [GameIds.IDIOMATICA]: 'Idiomatica',
      [GameIds.INKBLOTT]: 'Topo Listo',
      [GameIds.JUEGA_Y_CONJUGA]: 'Juega y Conjuga',
      [GameIds.LA_RANA_BRINCACHARCOS]: 'La Rana Brincacharcos',
      [GameIds.LETTER_SOUND_CORRESPONDENCES]: 'Letter Sound Correspondences',
      [AssessmentIds.LETTER_SOUND_CORRESPONDENCES_PLACEMENT]: 'Letter Sound Correspondences',
      [GameIds.MIND_THE_GAP]: 'Mind the Gap',
      [AssessmentIds.MIND_THE_GAP_PLACEMENT]: 'Mind the Gap',
      [GameIds.MESSAGE_IN_A_BOTTLE]: 'Mensajes del Mar',
      [GameIds.NEWSFLASH]: 'Newsflash',
      [GameIds.BOOST_FLUENCY]: 'Boost Fluency',
      [GameIds.PARROT_THEATER]: 'Parrot Theater',
      [GameIds.PICKY_GOBLINS]: 'Tragaletras Exigentes',
      [GameIds.PICTURE_THIS]: 'Picture This',
      [GameIds.PLANTORRES]: 'PlanTorres',
      [GameIds.POETS_PATH]: 'Poet\'s Path',
      [GameIds.PUNCHLINE]: 'Punchline!',
      [GameIds.READ_ALL_ABOUT_IT]: '¡Revisa y Reporta!',
      [GameIds.REAL_WORD_READING]: 'Real Word Reading',
      [AssessmentIds.REAL_WORD_READING_PLACEMENT]: 'Real Word Reading',
      [GameIds.RHYME_TIME]: 'Abra Palabra',
      [GameIds.SEGMENTING]: 'Segmenting',
      [GameIds.SHADES_OF_MEANING]: 'Shades of Meaning',
      [GameIds.SHOW_OFF]: 'Así Pasó',
      [GameIds.SILABALON]: 'Silabalón',
      [GameIds.SILABALON_LA_COPA]: 'Silabalón: La Copa',
      [GameIds.SLOPPY_SCROLLS]: 'Sloppy Scrolls',
      [GameIds.SORT_IT_OUT]: '¿Aquí o Allá?',
      [GameIds.STICKER_BOOK]: 'Sticker Book',
      [GameIds.STORYLAB]: 'Story Lab',
      [GameIds.CARTOON_FACTORY]: 'Cartoon Factory',
      [GameIds.SEGMENTING]: 'Segmenting',
      [AssessmentIds.SEGMENTING_PLACEMENT]: 'Segmenting',
      [GameIds.STORYBOARD]: 'Investiga la Escena',
      [GameIds.STORYBOX]: 'Storybox',
      [GameIds.SUPER_MATCH]: 'Super Match',
      [GameIds.SYLLABLE_DECODING]: 'Syllable Decoding',
      [AssessmentIds.SYLLABLE_DECODING_PLACEMENT]: 'Syllable Decoding',
      [GameIds.TONGUE_TWIST]: 'Quita y Pon',
      [GameIds.TUBE_TALES]: 'Tube Tales',
      [GameIds.UNMASK_THAT]: 'Unmask That',
      [GameIds.WHATS_THE_BIG_IDEA]: 'What\'s The Big Idea',
      [GameIds.WILD_PLANET]: 'Wild Planet',
      [GameIds.WORD_CITY]: 'LecTorres',
      [GameIds.WORD_RAIDERS]: 'Word Raiders',
      [GameIds.WORD_SLIDE]: 'Resbalaletras',
      [GameIds.WORDBOTS]: 'Jugando Ando',
      [GameIds.YEARBOOK]: 'Yearbook',
      [GameIds.ZOOM_BOOM]: 'Son Sabrosón',
      [GameIds.E_READER]: 'eReader',
      [GameIds.ROBOVOICE_PROTOTYPE]: 'Robovoice Prototype',
    },
  },
};
